import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import { clsx } from 'clsx';
import Logo from 'assets/img/sama/logo.png';
import Pama from 'assets/img/sama/pama.png';
import Silabus from 'assets/img/sama/silabus2026.jpg';

import { actions, types } from '@/modules/Guest';

import { Box, Flex } from 'UIKit/Grid';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';
import Panel from 'sama_global/components/Panel';
import { fetchSama } from 'sama_global/modules/olimpic';
import useStyles from './style';
import styles from './Signin.module.scss';
import SigninForm from './SigninForm';

/**
 * Signin page.
 * @param {object} values values.
 */

const Signin = ({ requests, user, login, sama, loadData }) => {
  const classes = useStyles();
  const request = requests[types.REQUEST_LOGIN];

  useSnackbarListener(request?.errorMessage);

  const handleSubmit = formData => {
    login(formData);
  };

  const history = useHistory();

  useEffect(() => {
    if (user._id) {
      history.push('/olimpic/about');
    }
  }, [user]);

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div>
        <Box
          w={['100% - 10px', '400px', '450px']}
          pt={[5, 20, 40]}
          pb={[20, 40]}
          mx={[5, 'auto']}
        >
          <Panel>
            <Box w="100%" position="relative" maxWidth="350px" mx="auto">
              <Box pb={3} pt={2}>
                <Flex alignItems="center" flexDirection="column" my={3}>
                  <Flex className={classes.logos}>
                    <Flex className={classes.logo}>
                      <img src={Logo} alt="" />
                    </Flex>
                    <Flex className={classes.logo}>
                      <img src={Pama} alt="" />
                    </Flex>
                  </Flex>
                  <Box mb={4} alignItems="center">
                    <Typography variant="h5" className={classes.title}>
                      <FormattedMessage id="signin.title" />
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle1">
                      <FormattedMessage id="signin.subtitle" />
                    </Typography>
                  </Box>
                </Flex>
                <SigninForm
                  onSubmit={handleSubmit}
                  isLoading={request?.loading}
                />
              </Box>
            </Box>
          </Panel>
        </Box>
      </div>

      <Flex
        maxWidth={1200}
        mx="auto"
        px={5}
        pb={10}
        flexDirection="column"
        style={{ gap: '60px' }}
      >
        {sama.desc && (
          <div>
            <Box mb={4}>
              <Typography variant="h5" className={classes.title}>
                <FormattedMessage id="DESCRIPTION" />
              </Typography>
            </Box>
            <Box dangerouslySetInnerHTML={{ __html: sama.desc }} />
          </div>
        )}
        <Flex alignItems="flex-start" flexDirection="column">
          <Box mb={4}>
            <Typography variant="h5" className={classes.title}>
              <FormattedMessage id="REGULATIONS" />
            </Typography>
          </Box>
          {sama.reglament && (
            <Flex className={clsx(styles.link, classes.link)}>
              <a href={sama.reglament} target="_blank" rel="noreferrer">
                {sama.reglament}
              </a>
            </Flex>
          )}
        </Flex>
        <div>
          <Box mb={4}>
            <Typography variant="h5" className={classes.title}>
              <FormattedMessage id="INFORMATION" />
            </Typography>
          </Box>
          <Box style={{ overflow: 'auto' }}>
            <img
              src={Silabus}
              alt=""
              style={{ minWidth: '800px', maxWidth: '1120px', width: '100%' }}
            />
          </Box>
        </div>
      </Flex>
    </>
  );
};

Signin.propTypes = {
  login: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  requests: PropTypes.object.isRequired,
  loadData: PropTypes.func.isRequired,
  sama: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
  requests: state.requests,
  olimpics: state.olimpic,
  sama: state.sama.sama,
});

const mapDispatchToProps = dispatch => ({
  login(formData) {
    dispatch(actions.fetchLogin(formData));
  },
  loadData() {
    dispatch(fetchSama());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Signin);
